<template>
    <textarea
        :id="question.label"
        rows="3"
        :placeholder="question.placeholder"
        class="form_control"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
